export const AVATARS = [
    '/avatars/avatar1.svg',
    '/avatars/avatar2.svg',
    '/avatars/avatar3.svg',
    '/avatars/avatar4.svg',
    '/avatars/avatar5.svg',
    '/avatars/avatar6.svg',
    '/avatars/avatar7.svg',
    '/avatars/avatar8.svg',
];
